
/*
 * NESTOUT Product Card Swatches
 * Hover to preview. Click to select.
 * Mobile: tap to select.
 * Preserves ADD TO CART and SOLD OUT labels.
 */

(function () {
  "use strict";

  const CARD_SELECTOR = "[data-nestout-product-card]";
  const SWATCH_SELECTOR = "[data-nestout-swatch]";

  function getCard(element) {
    return element.closest(CARD_SELECTOR);
  }

  function getImage(card) {
    return card.querySelector(".nestout-product-card__image");
  }

  function setImage(image, imageUrl) {
    if (!image || !imageUrl) return;

    if (!image.hasAttribute("data-nestout-original-src")) {
      image.dataset.nestoutOriginalSrc =
        image.getAttribute("src") || "";
      image.dataset.nestoutOriginalSrcset =
        image.getAttribute("srcset") || "";
      image.dataset.nestoutOriginalSizes =
        image.getAttribute("sizes") || "";
    }

    image.removeAttribute("srcset");
    image.removeAttribute("sizes");
    image.src = imageUrl;
  }

  function restoreInitialImage(image) {
    if (!image) return;

    const originalSrc = image.dataset.nestoutOriginalSrc;
    const originalSrcset = image.dataset.nestoutOriginalSrcset;
    const originalSizes = image.dataset.nestoutOriginalSizes;

    if (!originalSrc) return;

    image.src = originalSrc;

    if (originalSrcset) {
      image.setAttribute("srcset", originalSrcset);
    } else {
      image.removeAttribute("srcset");
    }

    if (originalSizes) {
      image.setAttribute("sizes", originalSizes);
    } else {
      image.removeAttribute("sizes");
    }
  }

  function getSelectedSwatch(card) {
    return card.querySelector(
      SWATCH_SELECTOR + ".is-active"
    );
  }

  function restoreSelectedImage(card) {
    const image = getImage(card);
    const selected = getSelectedSwatch(card);

    if (selected && selected.dataset.variantImage) {
      setImage(image, selected.dataset.variantImage);
    } else {
      restoreInitialImage(image);
    }
  }

  function selectSwatch(card, swatch) {
    const variantId = swatch.dataset.variantId;
    const variantUrl = swatch.dataset.variantUrl;
    const variantAvailable =
      swatch.dataset.variantAvailable === "true";
    const colorName = swatch.dataset.colorName || "";

    // Highlight the selected swatch.
    card.querySelectorAll(SWATCH_SELECTOR).forEach(
      function (item) {
        const selected = item === swatch;

        item.classList.toggle("is-active", selected);
        item.setAttribute(
          "aria-pressed",
          String(selected)
        );
      }
    );

    // Update the selected color label.
    const colorLabel = card.querySelector(
      "[data-selected-color]"
    );

    if (colorLabel) {
      colorLabel.textContent = colorName;
    }

    // Display the selected variant image.
    if (swatch.dataset.variantImage) {
      setImage(getImage(card), swatch.dataset.variantImage);
    }

    // Update the Shopify variant submitted to the cart.
    const variantInput = card.querySelector(
      "[data-nestout-variant-input]"
    );

    if (variantInput && variantId) {
      variantInput.value = variantId;

      variantInput.dispatchEvent(
        new Event("change", { bubbles: true })
      );
    }

    // Update product links to the selected variant.
    if (variantUrl) {
      card.querySelectorAll(
        "[data-nestout-product-link]"
      ).forEach(function (link) {
        link.href = variantUrl;
      });
    }

    // Update availability without changing CTA wording.
    const addButton = card.querySelector(
      "[data-nestout-add-button]"
    );

    if (addButton) {
      const availableLabel =
        addButton.dataset.nestoutAvailableLabel ||
        "ADD TO CART";

      const unavailableLabel =
        addButton.dataset.nestoutUnavailableLabel ||
        "SOLD OUT";

      addButton.disabled = !variantAvailable;

      addButton.textContent = variantAvailable
        ? availableLabel
        : unavailableLabel;
    }
  }

  // Click/tap selects the variant permanently.
  document.addEventListener("click", function (event) {
    const swatch = event.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;

    const card = getCard(swatch);
    if (!card) return;

    event.preventDefault();
    selectSwatch(card, swatch);
  });

  // Hover previews the color without selecting it.
  document.addEventListener("pointerover", function (event) {
    if (
      !window.matchMedia(
        "(hover: hover) and (pointer: fine)"
      ).matches
    ) {
      return;
    }

    const swatch = event.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;

    const card = getCard(swatch);
    if (!card) return;

    if (
      event.relatedTarget &&
      swatch.contains(event.relatedTarget)
    ) {
      return;
    }

    if (swatch.dataset.variantImage) {
      setImage(getImage(card), swatch.dataset.variantImage);
    }
  });

  // Moving away restores the selected variant image.
  document.addEventListener("pointerout", function (event) {
    if (
      !window.matchMedia(
        "(hover: hover) and (pointer: fine)"
      ).matches
    ) {
      return;
    }

    const swatch = event.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;

    const card = getCard(swatch);
    if (!card) return;

    if (
      event.relatedTarget &&
      swatch.contains(event.relatedTarget)
    ) {
      return;
    }

    const nextSwatch =
      event.relatedTarget instanceof Element
        ? event.relatedTarget.closest(SWATCH_SELECTOR)
        : null;

    if (nextSwatch && getCard(nextSwatch) === card) {
      return;
    }

    restoreSelectedImage(card);
  });
})();
